














import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({})
export default class CircleIcon extends Vue {
  @Prop(Boolean) withOuterCircle!: boolean;
  @Prop(String) color!: string;
  @Prop({ type: String, default: 'black' }) outerCircleColor!: string;
  @Prop({ type: Number, default: 1 }) outerCircleStrokeWidth!: number;
}
